<template>
  <!-- Importing Reset Password Component -->
  <ForgotPasswordComp></ForgotPasswordComp>
</template>
<script>
import ForgotPasswordComp from "../../components/Auths/ForgotPassword.vue";

export default {
  name: "Password Reset",
  components: { ForgotPasswordComp },
  computed: {},
  mounted() {},
};
</script>
